import { render, staticRenderFns } from "./AddComment.vue?vue&type=template&id=07bc1e7e"
import script from "./AddComment.vue?vue&type=script&lang=js"
export * from "./AddComment.vue?vue&type=script&lang=js"
import style0 from "./AddComment.vue?vue&type=style&index=0&id=07bc1e7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports